import Breadcrumbs from "components/Common/Breadcrumb";
import AutoReloadList from "components/shared-components/AutoReload/AutoReloadList";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { env } from "configs/EnvironmentConfig";
import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_P,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_CANCEL,
  AUTH_STATUS_CANCEL_WAITING,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  AUTH_STATUS_REJECT,
  AUTH_STATUS_REJECT_CANCEL,
  AUTH_STATUS_RR,
  AUTH_STATUS_RRE,
  CLIENT_TYPE_CONST,
  TYPE_TRANSFER,
} from "constants/FormatDataContanst";
import {
  LINK_TYPE,
  MODE_INVOICE_POS_ACTION,
  TYPE_ACTION_WORKFLOW,
  TYPE_ADJUST_INVOICE_POS,
  TYPE_INVOICE_POS_ANOTHER,
} from "constants/InvoicePosConstant";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { TENANT_CODE } from "constants/TennantConstant";
import { getResourceIdXML } from "helpers/form_helper";
import {
  getDefaultQueryFilter,
  getDefaultValueFilter,
  toastWarningIsAllStore,
} from "helpers/utils";
import { useGetFilter } from "hook";
import jwt_decode from "jwt-decode";
import ErrorReleaseModal from "pages/DataFormatInvoice/modal/ErrorReleaseModal";
import HistoryMailTransferModal from "pages/DataFormatInvoice/modal/HistoryMailTransferModal";
import HistoryTransferModal from "pages/DataFormatInvoice/modal/HistoryTransferModal";
import NoteModal from "pages/DataFormatInvoice/modal/NoteModal";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import PropTypes from "prop-types";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import {
  actionWorkflowInvoicePos,
  cancelInvoicePos,
  deleteInvoicePos,
  downloadXmlInvoicePos,
  getCloneEnvoicePos,
  getDataLinkPos,
  getInvoicePosMinDate,
  listInvoicePos,
  listInvoiceSymbol,
  releaseInvoicePos,
  resetActionWorkflowInvoicePos,
  resetAdjustInvoicePos,
  resetBackupDataNew,
  resetCancelInvoicePos,
  resetCloneEnvoicePos,
  resetCreateInvoicePosEnterprise,
  resetDeleteInvoicePos,
  resetDownloadXmlInvoicePos,
  resetDownloadZipInvoicePos,
  resetExportInvoicePos,
  resetGetInvoicePosMinDate,
  resetGetInvoicePosReportWord,
  resetListInvoicePos,
  resetListInvoiceSymbol,
  resetReleaseInvoicePos,
  resetReplaceInvoicePos,
  resetUploadFileInvoicePos,
  setListInvoicePosColumn,
} from "store/actions";
import {
  AUTH_TOKEN,
  BU_STORE_HEADER,
  ROLE_EINVOICE_CONTINUE_SEND_MAIL,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
  ROLE_VIEW_ORIGINAl_PDF,
} from "store/auth/login/actionTypes";
import {
  ACTION_WORKFLOW_INVOICE_POS_FAIL,
  ACTION_WORKFLOW_INVOICE_POS_SUCCESS,
  ADJUST_INVOICE_POS_FAIL,
  ADJUST_INVOICE_POS_SUCCESS,
  CANCEL_INVOICE_POS_FAIL,
  CANCEL_INVOICE_POS_SUCCESS,
  CREATE_INVOICE_POS_ENTERPRISE_FAIL,
  CREATE_INVOICE_POS_ENTERPRISE_SUCCESS,
  DELETE_INVOICE_POS_FAIL,
  DELETE_INVOICE_POS_SUCCESS,
  DOWNLOAD_XML_INVOICE_POS_FAIL,
  DOWNLOAD_XML_INVOICE_POS_SUCCESS,
  DOWNLOAD_ZIP_INVOICE_POS_FAIL,
  DOWNLOAD_ZIP_INVOICE_POS_SUCCESS,
  EXPORT_INVOICE_POS_FAIL,
  EXPORT_INVOICE_POS_SUCCESS,
  GET_INVOICE_POS_MIN_DATE_FAIL,
  GET_INVOICE_POS_MIN_DATE_SUCCESS,
  GET_INVOICE_POS_REPORT_WORD_FAIL,
  GET_INVOICE_POS_REPORT_WORD_SUCCESS,
  REPLACE_INVOICE_POS_FAIL,
  REPLACE_INVOICE_POS_SUCCESS,
  UPLOAD_FILE_INVOICE_POS_FAIL,
  UPLOAD_FILE_INVOICE_POS_SUCCESS,
} from "store/invoice-pos/actionTypes";
import DetailInvoicePos from "./DetailInvoicePos";
import { getInvoiceStatus } from "./helper/functionHelper";
import CompareInvoiceModal from "./modal/CompareInvoiceModal";
import ConfirmActionInvoice from "./modal/ConfirmActionInvoice";
import ConfirmCancelInvoiceModal from "./modal/ConfirmCancelInvoiceModal";
import PDFViewModal from "./modal/PDFViewModal";
import SendMailModal from "./modal/SendMailModal";
import SignHSMModal from "./modal/SignHSMModal";
import TypeSignDigitalModal from "./modal/TypeSignDigitalModal";
import UploadFileAttack from "./modal/UploadFileAttack";
import VerifyPinUSBModal from "./modal/VerifyPinUSBModal";
import {
  COMMON_CONDITION_VISIBLE,
  checkDateWhenRelease,
  formatHiddenColumn,
  getPhaseInvoicePosStatus,
  getRowInvoiceReplaceAdjustInfo,
  getTypeWorkflowMessage,
  invoicePosModeList,
  invoicePosPageViewList,
} from "./utils";

const ListInvoicePosBatchDetail = forwardRef((props, ref) => {
  const {
    filterList,
    title,
    titleManger,
    listStatusFilter,
    listLinkTypeFilter,
    screenFilterCode,
    isModal,
    typeInvoicePosAnother,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["invoicePos"]);
  const { addToast, removeToast, toastStack } = useToasts();

  const [idReportToastRemove, setIdReportToastRemove] = useState(null);

  const invoicePos = useSelector(state => state.invoicePos);
  const {
    loadingList,
    errorList,
    list: invoicePosList,
    fileDownload,
    fileDownloadName,
    type,
    deleteInvoice,
    cancelInvoice,
    successClone,
    workflowInvoice,
    exportInvoiceData,
    linkTypeData,
    adjustInvoice: adjustInvoiceData,
    replaceInvoice: replaceInvoiceData,
    createInvoiceEnterpriseData,
    invoiceMaxDate,
    invoiceMaxMinDate,
    downloadZipInvoiceData,
    bkDataNew,
  } = invoicePos;

  const childRef = useRef();
  const invoiceSymbol = useSelector(state => state.invoiceSymbol);
  const { errorList: errorInvoiceSymbolList, list: invoiceSymbolList } =
    invoiceSymbol;

  const [commonStatus, setCommonStatus] = useState(getInvoiceStatus(t));
  const [commonStatusPhase, setCommonStatusPhase] = useState(
    getPhaseInvoicePosStatus(t)
  );

  useEffect(() => {
    if (idReportToastRemove) {
      const stack = toastStack.find(
        item => item.idreport === idReportToastRemove
      );
      if (stack) {
        removeToast(stack.id);
      }
      setIdReportToastRemove(null);
    }
  }, [idReportToastRemove]);

  const [mode, setMode] = useState("");
  const [columnsTable, setColumnsTable] = useState([]);

  const [pageView, setPageView] = useState(null);

  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);
  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);

  // toggleSendMailModal
  const [modalSendMail, setModalSendMail] = useState(false);
  const toggleSendMailModal = () => setModalSendMail(!modalSendMail);
  const [mailData, setMailData] = useState({
    idInvoice: null,
    mailDefault: null,
  });
  // modalTypeSign
  const [transferData, setTransferData] = useState(null);
  const [modalTypeSign, setModalTypeSign] = useState(false);
  const toggleTypeSignModal = () => setModalTypeSign(!modalTypeSign);
  // modalUSB
  const [modalUSBSign, setModalUSBSign] = useState(false);
  const toggleUSBSignModal = () => setModalUSBSign(!modalUSBSign);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // Confirm Cancel modal
  const [modalConfirmCancel, setModalConfirmCancel] = useState(false);
  const toggleConfirmCancelModal = () =>
    setModalConfirmCancel(!modalConfirmCancel);
  // CompareInvoiceModal
  const [dataCompare, setDataCompare] = useState(null);
  const [modalCompareInvoice, setModalCompareInvoice] = useState(false);
  const toggleCompareInvoiceModal = () =>
    setModalCompareInvoice(!modalCompareInvoice);
  // modalConfirmAction (Replace or Adjust invoice)
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const [modalConfirmAction, setModalConfirmAction] = useState(false);
  const toggleConfirmActionModal = () =>
    setModalConfirmAction(!modalConfirmAction);
  // modalErrorRelease
  const [idRelease, setIdRelease] = useState(null);
  const [pathErrorRelease, setPathErrorRelease] = useState(null);
  const [modalErrorRelease, setModalErrorRelease] = useState(false);
  const toggleErrorReleaseModal = () =>
    setModalErrorRelease(!modalErrorRelease);
  // modalHistoryTransfer
  const [idHistory, setIdHistory] = useState(null);
  const [modalHistoryTransfer, setModalHistoryTransfer] = useState(false);
  const toggleHistoryTransferModal = () =>
    setModalHistoryTransfer(!modalHistoryTransfer);
  // modalHistoryMailTransfer
  const [idHistoryMail, setIdHistoryMail] = useState(null);
  const [modalHistoryMailTransfer, setModalHistoryMailTransfer] =
    useState(false);
  const toggleHistoryMailTransferModal = () =>
    setModalHistoryMailTransfer(!modalHistoryMailTransfer);
  // modalHSM
  const [modalHSMSign, setModalHSMSign] = useState(false);
  const toggleHSMSignModal = () => setModalHSMSign(!modalHSMSign);
  // Workflow modal
  const [modalWorkflow, setModalWorkflow] = useState(false);
  const toggleWorkflowModal = () => setModalWorkflow(!modalWorkflow);
  const [dataWorkflow, setDataWorkflow] = useState({
    id: null,
    typeWorkFlow: null,
    titleModal: null,
    bodyModal: null,
  });
  // Lí do từ chối duyệt
  const [noteReject, setNoteReject] = useState(null);
  const [modalReject, setModalReject] = useState(false);
  const toggleRejectModal = () => setModalReject(!modalReject);
  // Update File modal
  const [idRootInvoice, setIdRootInvoice] = useState(false);
  const [modalUploadFile, setModalUploadFile] = useState(false);
  const toggleUploadFileModal = () => setModalUploadFile(!modalUploadFile);

  // modalCheckRelease
  const [rowRelease, setRowRelease] = useState(null);
  const [titleBodyCheckRelease, setTitleBodyCheckRelease] = useState("");
  const [modalCheckRelease, setModalCheckRelease] = useState(false);
  const toggleCheckReleaseModal = () =>
    setModalCheckRelease(!modalCheckRelease);

  // modalDenyRelease
  const [titleBodyDenyRelease, setTitleBodyDenyRelease] = useState("");
  const [modalDenyRelease, setModalDenyRelease] = useState(false);
  const toggleDenyReleaseModal = () => setModalDenyRelease(!modalDenyRelease);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader, finalBuInfo, buStoreHeader, finalListBuCode } =
    Dashboard;

  const history = useHistory();

  const [isEnterprise, setIsEnterprise] = useState(false);
  const [isCreateAdjust, setIsCreateAdjust] = useState(false);
  const [idAdjust, setIdAdjust] = useState(false);

  const {
    isLoading: isLoadingDefaultFilter,
    isSuccess: isSuccessDefaultFilter,
    data: dataDefaultFilter,
    refetch: refetchDefaultFilter,
  } = useGetFilter(screenFilterCode);

  const [invoiceSelect, setInvoiceSelect] = useState([]);
  const selectRowCheckbox = {
    mode: "checkbox",
    nonSelectable:
      invoicePosList?.items
        .filter(item => item.auth_status !== AUTH_STATUS_APPROVE)
        .map(item => item.id) || [],
  };
  const onRowsSelect = value => {
    setInvoiceSelect(value);
  };

  const queryData = (isLoadDefaultFilter = false, showLoading = true) => {
    const userCode = jwtInfo?.userInfo?.userCode;
    setInvoiceSelect([]);
    // // Role kế toán chỉ xem hóa đơn chờ duyệt và đã duyệt và của chính nó tạo
    // if (
    //   isRoleAccountant &&
    //   finalBuInfo?.need_approve === 1 &&
    //   !invoicePosList.params.columnFilter["filter[approve_status]"] &&
    //   !typeInvoicePosAnother
    // ) {
    //   invoicePosList.params.columnFilter = {
    //     ...invoicePosList.params.columnFilter,
    //     "filter[or][0][approve_status][in]": [
    //       APPROVE_STATUS_P,
    //       APPROVE_STATUS_A,
    //     ],
    //     "filter[or][1][maker_id]": userCode,
    //   };
    // }
    if (invoicePosList.params.columnFilter["filter[auth_status]"]) {
      delete invoicePosList.params.columnFilter["filter[auth_status][in]"];
    }
    if (invoicePosList.params.columnFilter["filter[link_type]"]) {
      delete invoicePosList.params.columnFilter["filter[link_type][in]"];
    }
    // Load defaultFilter
    if (isLoadDefaultFilter) {
      invoicePosList.params.columnFilter = {
        ...invoicePosList.params.columnFilter,
        ...getDefaultQueryFilter(dataDefaultFilter),
      };
    }
    dispatch(
      listInvoicePos(
        invoicePosList.params,
        TYPE_INVOICE_POS_ANOTHER.INVOICE_BATCH_DETAILS,
        showLoading
      )
    );
  };

  // Action list chang tenantCode
  useEffect(() => {
    if (finalBuInfo && isSuccessDefaultFilter) {
      invoicePosList.params.page = 1;
      invoicePosList.params.columnFilter = {
        ...invoicePosList.params.columnFilter,
        ...filterList,
        // "filter[invoice_type]": finalBuInfo?.invoice_type,
      };
      queryData(true);
      generateBtnFooter();
    }
  }, [finalBuInfo, isSuccessDefaultFilter]);

  useEffect(() => {
    if (tenantCodeHeader) {
      setIsEnterprise(tenantCodeHeader === TENANT_CODE.GUARDIAN);
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    if (finalBuInfo?.copy_pdf) {
      setIsBuHavePdfCopy(true);
    }
    if (finalBuInfo?.prevent_send_mail_from_second) {
      setIsPreventSendMailFromSecond(true);
    }
  }, [finalBuInfo]);

  useEffect(() => {
    initColumn(false);
  }, [invoicePosList.items]);

  useEffect(() => {
    if (successClone && tenantCodeHeader) {
      invoicePosList.params.page = 1;
      invoicePosList.params.columnFilter = {
        ...invoicePosList.params.columnFilter,
        ...filterList,
      };
      queryData();
      addToast("Đã nhân bản tờ hóa đơn", {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(resetCloneEnvoicePos());
    }
  }, [successClone, tenantCodeHeader]);
  // Action list And Change Language
  useEffect(() => {
    // Set default value to page|sizePerPage when change Language
    if (isSuccessDefaultFilter) {
      invoicePosList.params.page = 1;
      invoicePosList.params.sizePerPage = 10;
      invoicePosList.params.columnFilter = {
        ...invoicePosList.params.columnFilter,
        ...filterList,
      };
      initColumn(true);
    }
  }, [isSuccessDefaultFilter]);

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [jwtInfo, setJwtInfo] = useState(null);
  const [isRoleStore, setIsRoleStore] = useState(false);
  const [isRoleAccountant, setIsRoleAccountant] = useState(false);
  const [isRoleViewOriginalPdf, setIsRoleViewOriginalPdf] = useState(false);
  const [isRoleContinueSendMail, setIsRoleContinueSendMail] = useState(false); // Check quyền dc gửi mail tiếp sau khi gửi mail thành công
  const [isBuHavePdfCopy, setIsBuHavePdfCopy] = useState(false);
  const [isPreventSendMailFromSecond, setIsPreventSendMailFromSecond] =
    useState(false);

  const [btnShowFooter, setBtnShowFooter] = useState({
    btnSubmitEdit: {
      isShow: false,
      onClick: null,
      toggleModal: null,
    },
  });

  const [isSendSubmitEdit, setIsSendSubmitEdit] = useState(false);

  const generateBtnFooter = () => {
    setBtnShowFooter({
      btnSubmitEdit: {
        isShow:
          finalBuInfo?.need_approve === 1 &&
          buStoreHeader !== ALL_STORE &&
          buStoreHeader !== ALL_BU,
        listConditionRow: [
          COMMON_CONDITION_VISIBLE.REPLACE,
          COMMON_CONDITION_VISIBLE.ADJUST,
        ],
        onClick: () => {
          setIsSendSubmitEdit(true);
        },
        toggleModal: null,
      },
    });
  };

  // Action Dispatch
  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    setJwtInfo(info);
    const roleUser = info?.["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
      setIsRoleAccountant(
        listRole.findIndex(item => item === ROLE_EINVOICE_KE_TOAN) !== -1
          ? true
          : false
      );
      setIsRoleViewOriginalPdf(
        listRole.findIndex(item => item === ROLE_VIEW_ORIGINAl_PDF) !== -1
          ? true
          : false
      );
      setIsRoleContinueSendMail(
        listRole.findIndex(
          item => item === ROLE_EINVOICE_CONTINUE_SEND_MAIL
        ) !== -1
          ? true
          : false
      );
    }
    refetchDefaultFilter();
    return () => {
      dispatch(resetListInvoicePos());
    };
  }, []);

  const location = useLocation();

  // Error Dispatch
  useEffect(() => {
    if (errorList && errorList.message) {
      addToast(errorList.message, {
        appearance: "error",
        autoDismiss: true,
      });
      dispatch(resetListInvoicePos());
    }

    if (errorInvoiceSymbolList) {
      addToast(
        errorInvoiceSymbolList.message ||
          t("message.list", {
            target: t("invoice_symbol"),
            status: t("message.error"),
          }),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListInvoiceSymbol());
    }
  }, [addToast, dispatch, errorInvoiceSymbolList, errorList, t]);

  // Get list KHHD
  const getListInvoiceSymbol = ttchung_khmshdon => {
    invoiceSymbolList.params.page = -1;
    invoiceSymbolList.params.sort = "name";
    invoiceSymbolList.params.columnFilter = {
      "filter[record_status]": "O",
      "filter[bu_code]": localStorage.getItem(BU_STORE_HEADER),
      "filter[khmhdon]": ttchung_khmshdon,
    };
    invoiceSymbolList.params.fields =
      "id,khmhdon,khhdon,bu_code,record_status,tenant_code,";
    dispatch(listInvoiceSymbol(invoiceSymbolList.params));
  };

  useEffect(() => {
    switch (type) {
      case GET_INVOICE_POS_REPORT_WORD_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetGetInvoicePosReportWord());
        break;
      }
      case GET_INVOICE_POS_REPORT_WORD_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetGetInvoicePosReportWord());
        break;
      //
      case DOWNLOAD_XML_INVOICE_POS_SUCCESS: {
        if (!modalUSBSign) {
          if (fileDownload !== null) {
            const link = document.createElement("a");
            link.href = fileDownload;
            link.setAttribute("download", fileDownloadName);
            document.body.appendChild(link);
            link.click();
          }
          addToast("Tải xuống thành công", {
            appearance: "success",
            autoDismiss: true,
          });
        }

        dispatch(resetDownloadXmlInvoicePos());
        break;
      }
      case DOWNLOAD_XML_INVOICE_POS_FAIL:
        if (!modalUSBSign) {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetDownloadXmlInvoicePos());
        break;
      case REPLACE_INVOICE_POS_SUCCESS:
        addToast("Lập hóa đơn thay thế thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        dispatch(resetReplaceInvoicePos());
        // Thay thế xong gửi duyệt lun
        if (isSendSubmitEdit) {
          dispatch(
            actionWorkflowInvoicePos(
              replaceInvoiceData?.data?.id,
              TYPE_ACTION_WORKFLOW.SUBMIT,
              null
            )
          );
          setIsSendSubmitEdit(false);
        } else {
          resetDataFunc();
        }
        break;
      case REPLACE_INVOICE_POS_FAIL:
        if (
          replaceInvoiceData?.error?.root_id?.includes(
            "Have invoice child not handle"
          )
        ) {
          addToast(
            "Lập hóa đơn thay thế thất bại, tồn tại hóa đơn thay thế chưa phát hành",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        } else {
          addToast("Lập hóa đơn thay thế thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }

        dispatch(resetReplaceInvoicePos());
        break;
      case ADJUST_INVOICE_POS_SUCCESS:
        addToast("Lập hóa đơn điều chỉnh thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleDetailModal();
        dispatch(resetAdjustInvoicePos());
        // Điều chỉnh xong gửi duyệt lun
        if (isSendSubmitEdit) {
          dispatch(
            actionWorkflowInvoicePos(
              adjustInvoiceData?.data?.id,
              TYPE_ACTION_WORKFLOW.SUBMIT,
              null
            )
          );
          setIsSendSubmitEdit(false);
        } else {
          resetDataFunc();
        }
        break;
      case ADJUST_INVOICE_POS_FAIL:
        if (
          adjustInvoiceData?.error?.root_id?.includes(
            "Have invoice child not handle"
          )
        ) {
          addToast(
            "Lập hóa đơn điều chỉnh thất bại, tồn tại hóa đơn điều chỉnh chưa phát hành",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        } else {
          addToast("Lập hóa đơn điều chỉnh thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetAdjustInvoicePos());
        break;
      case DELETE_INVOICE_POS_SUCCESS:
        addToast("Xóa hóa đơn thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmDeleteModal();
        resetDataFunc();
        dispatch(resetDeleteInvoicePos());
        break;
      case DELETE_INVOICE_POS_FAIL:
        addToast(deleteInvoice.error, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDeleteInvoicePos());
        break;

      case CANCEL_INVOICE_POS_SUCCESS:
        addToast("Gửi yêu cầu hủy hóa đơn thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleConfirmCancelModal();
        resetDataFunc();
        dispatch(resetCancelInvoicePos());
        break;
      case CANCEL_INVOICE_POS_FAIL:
        addToast("Gửi yêu cầu hủy hóa đơn thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCancelInvoicePos());
        break;

      case ACTION_WORKFLOW_INVOICE_POS_SUCCESS: {
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkflow) + " thành công";
        addToast(mess, {
          appearance: "success",
          autoDismiss: true,
        });
        if (modalWorkflow) {
          toggleWorkflowModal();
        }
        resetDataFunc();
        if (workflowInvoice.typeWorkflow === TYPE_ACTION_WORKFLOW.APPROVE) {
          toggleTypeSignModal();
        }
        dispatch(resetActionWorkflowInvoicePos());
        break;
      }
      case ACTION_WORKFLOW_INVOICE_POS_FAIL:
        let mess =
          getTypeWorkflowMessage(workflowInvoice.typeWorkFlow) + " thất bại";
        addToast(mess, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetActionWorkflowInvoicePos());
        break;
      //
      case CREATE_INVOICE_POS_ENTERPRISE_SUCCESS: {
        addToast("Tạo hóa đơn doanh nghiệp thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetCreateInvoicePosEnterprise());
        if (createInvoiceEnterpriseData?.data?.id) {
          history.push(`/invoice-pos/${createInvoiceEnterpriseData?.data?.id}`);
        }
        break;
      }
      case CREATE_INVOICE_POS_ENTERPRISE_FAIL:
        addToast("Tạo hóa đơn doanh nghiệp thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetCreateInvoicePosEnterprise());
        break;
      case UPLOAD_FILE_INVOICE_POS_SUCCESS: {
        addToast("Upload biên bản đính kèm thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        toggleUploadFileModal();
        dispatch(resetUploadFileInvoicePos());
        break;
      }
      case UPLOAD_FILE_INVOICE_POS_FAIL:
        addToast("Upload biên bản đính kèm thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetUploadFileInvoicePos());
        break;

      case EXPORT_INVOICE_POS_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetExportInvoicePos());
        break;
      }
      case EXPORT_INVOICE_POS_FAIL:
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        if (exportInvoiceData?.error?.response?.status === 413) {
          addToast("Vui lòng giảm bớt số cột cần xuất dữ liệu", {
            appearance: "error",
            autoDismiss: true,
          });
        }
        dispatch(resetExportInvoicePos());
        break;
      case GET_INVOICE_POS_MIN_DATE_SUCCESS:
        if (!detailModal) {
          checkDateWhenRelease(
            invoiceMaxMinDate.data.min,
            invoiceMaxMinDate.data.max,
            new Date(rowRelease.ttchung_nlap * 1000),
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyDenyRelease(
                `Đã có hóa đơn phát hành ngày ${maxDateLabel}. Vui lòng  cập nhật ngày lập của HĐ hiện tại về ${maxDateLabel} hoặc lớn hơn (nhưng phải nhỏ hơn ngày hiện tại).`
              );
              toggleDenyReleaseModal();
            },
            (nlapLabel, minDateLabel, maxDateLabel) => {
              setTitleBodyCheckRelease(
                `Đang có Hóa Đơn lưu tạm có ngày lập (${minDateLabel}) nhỏ hơn ngày lập của hóa đơn hiện tại (${nlapLabel}), bạn có muốn tiếp tục phát hành hóa đơn này hay không?`
              );
              toggleCheckReleaseModal();
            },
            () => {
              releaseInvoiceFunc(rowRelease);
            }
          );
          dispatch(resetGetInvoicePosMinDate());
        }
        break;
      case GET_INVOICE_POS_MIN_DATE_FAIL:
        if (!detailModal) {
          addToast("Lấy thông tin ngày lập hóa đơn lưu tạm xa nhất thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetGetInvoicePosMinDate());
        }
        break;
      case DOWNLOAD_ZIP_INVOICE_POS_SUCCESS: {
        if (downloadZipInvoiceData.data) {
          //   const link = document.createElement("a");
          //   link.href = fileDownload;
          //   link.setAttribute("download", fileDownloadName);
          //   document.body.appendChild(link);
          //   link.click();
          let name = "";
          switch (downloadZipInvoiceData.data.typeFile) {
            case "pdf":
              name = "bản hiển thị";
              break;
            case "convert-pdf":
              name = "bản chuyển đổi";
              break;
            case "xml":
              name = "XML";
              break;
            default:
              break;
          }
          addToast(
            `Khởi tạo file zip ${name}. 
             Id bảng kê: ${downloadZipInvoiceData.data.report_id}. 
             <span style="font-weight: bold">Click để mở chi tiết.</span>`,
            {
              appearance: "success",
              idreport: downloadZipInvoiceData.data.report_id,
              onClick: id => {
                if (typeof id === "number") {
                  console.log(
                    "🚀 ~ file: ListInvoicePosBatchDetail.js ~ line 851 ~ useEffect ~ id",
                    id
                  );
                  window.open(`/report/list-zip-file/${id}`, "_blank");
                  setIdReportToastRemove(id);
                }
              },
              autoDismiss: false,
            }
          );
        }
        dispatch(resetDownloadZipInvoicePos());
        break;
      }
      case DOWNLOAD_ZIP_INVOICE_POS_FAIL:
        addToast("Tạo file thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDownloadZipInvoicePos());
        break;
      default:
        break;
    }
  }, [type]);

  const initColumn = (loadDefaultFilter = false) => {
    const columns = getInitColumns(loadDefaultFilter);
    let columnsVisibleInvoice = dataDefaultFilter?.columnsVisible;
    setColumnsTable(formatHiddenColumn(columnsVisibleInvoice, columns));
  };

  const resetFilterHandle = () => {
    // Reset colums
    const columns = getInitColumns(false);
    let columnsVisibleInvoice = dataDefaultFilter?.columnsVisible;
    setColumnsTable(formatHiddenColumn(columnsVisibleInvoice, columns));
    // Reset filter call api
    invoicePosList.params.columnFilter = {
      ...filterList,
      // "filter[invoice_type]": finalBuInfo?.invoice_type,
    };
    delete invoicePosList.params.keywords;
    resetDataFunc();
  };

  const optionShowColumnHandler = (field, value) => {
    let indexTargetColumn = columnsTable.findIndex(
      item => item.dataField === field
    );
    if (indexTargetColumn > -1) {
      // Get column with defaultValuefilter
      const columnsWithFilter = getInitColumns(true).find(
        item => item.dataField === field
      );
      columnsWithFilter.hidden = !value;
      // Set lại cho default fitler cho column ẩn/hiện hiện tại
      columnsTable[indexTargetColumn] = columnsWithFilter;
    }
    setColumnsTable(columnsTable);
    dispatch(setListInvoicePosColumn(field, value));
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    invoicePosList.params.sort = sortField
      ? sortOrder + sortField
      : invoicePosList.params.sort;
    invoicePosList.params.columnFilter =
      { ...columnFilter, ...filterList } || {};
    invoicePosList.params.page = page || 1;
    invoicePosList.params.sizePerPage = sizePerPage || 10;
    queryData();
  };

  const onSearchAllHandle = value => {
    invoicePosList.params.keywords = value;
    invoicePosList.params.columnFilter = {
      ...invoicePosList.params.columnFilter,
      ...filterList,
    };
    queryData();
  };

  const toggleDetailModal = (
    modeSet = "",
    isPage = false,
    isReloadPage = false
  ) => {
    if (isReloadPage) {
      invoicePosList.params.columnFilter = {
        ...invoicePosList.params.columnFilter,
        ...filterList,
      };
      setDetailModal(!detailModal);
      queryData();
      return;
    }
    if (isPage) {
      history.push("/invoice-pos/all");
      return;
    }
    setDetailModal(!detailModal);
    switch (modeSet) {
      case invoicePosModeList.CREATE_VAT_INVOICE_DETAIL:
      case invoicePosModeList.CREATE_SALE_INVOICE_DETAIL:
      case invoicePosModeList.EDIT_VAT_INVOICE_DETAIL:
      case invoicePosModeList.EDIT_SALE_INVOICE_DETAIL:
        invoicePosList.params.page = 1;
        invoicePosList.params.sizePerPage = 10;
        invoicePosList.params.columnFilter = {
          ...invoicePosList.params.columnFilter,
          ...filterList,
        };
        queryData();
        break;
      default:
        break;
    }
  };
  const toastAddInvoice = () => {
    return addToast("Bạn chưa đăng ký sử dụng loại hóa đơn này", {
      appearance: "error",
      autoDismiss: true,
    });
  };

  const showPdfById = (id, isConvert = false, isNoneCopy = false) => {
    setDataViewDocument({
      id,
      isConvert,
      isNoneCopy,
    });
    togglePdfViewModal();
  };

  const showPdfReturnGoodsById = id => {
    setDataViewDocument({
      id,
      isPolicy: true,
    });
    togglePdfViewModal();
  };

  const showSendMail = row => {
    setMailData({
      idInvoice: row.invoice_id,
      mailDefault: row.nmua_dctdtu,
    });
    toggleSendMailModal();
  };

  const checkBeforeRelease = row => {
    if (toastWarningIsAllStore(addToast)) {
      return;
    }
    setRowRelease(row);
    dispatch(
      getInvoicePosMinDate(
        row?.ttchung_khmshdon,
        row?.ttchung_khhdon,
        row?.bu_code
      )
    );
  };

  const releaseInvoiceFunc = row => {
    // Nếu có liên kết hóa đơn lẻ và k phải hóa đơn thay thế thì mới tạo hóa đơn điều chỉnh 100%
    if (row.passersbyRoot && row.tthdlquan_tchdon === null) {
      setIsCreateAdjust(true);
      setIdAdjust(row.passersbyRoot.id);
    } else {
      setIsCreateAdjust(false);
    }
    setTransferData({
      id: row.invoice_id,
      mst: row.nban_mst,
      resource_id: getResourceIdXML(row.resource_list, "raw"),
      type: TYPE_TRANSFER.INVOICE,
      invoice_type: row.invoice_type,
    });
    toggleTypeSignModal();
  };

  const rowEventsHandler = {
    onDoubleClick: (e, row, rowIndex) => {
      //   getListInvoiceSymbol(row.ttchung_khmshdon);
      if (row.adjust_mod) {
        setDataConfirmAction({
          typeAdjust: row.adjust_mod,
        });
      } else {
        setDataConfirmAction(null);
      }

      setPageViewByRow(row);
      setDataDetail({
        id: row.invoice_id,
        tthdlquan_tchdon: row.tthdlquan_tchdon,
        root: row.root,
        child: row.child,
        tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
        tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
        tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
        tthdlquan_shdclquan: row.tthdlquan_shdclquan,
        tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
      });
      switch (row.ttchung_khmshdon) {
        case "1":
          setMode(invoicePosModeList.VIEW_VAT_INVOICE_DETAIL);
          break;
        case "2":
          setMode(invoicePosModeList.VIEW_SALE_INVOICE_DETAIL);
          break;
        default:
          break;
      }
      toggleDetailModal();
    },
  };
  const cloneEnvoice = id => {
    let approveStatus = undefined;
    if (isRoleAccountant) {
      approveStatus = APPROVE_STATUS_A;
    }
    dispatch(getCloneEnvoicePos(id, null, approveStatus));
  };

  const listRowAction = [
    {
      icon: <i className="mdi mdi-arrow-right-circle text-success" />,
      styleDivIcon: { marginTop: "5px" },
      text: "Gửi duyệt hóa đơn",
      isShow:
        finalBuInfo?.need_approve === 1 && (isRoleStore || isRoleAccountant),
      conditionVisible: COMMON_CONDITION_VISIBLE.SEND_APPROVE,
      onClick: row => {
        setDataWorkflow({
          id: row.invoice_id,
          typeWorkFlow: TYPE_ACTION_WORKFLOW.SUBMIT,
          titleModal: "Xác nhận gửi duyệt hóa đơn",
          bodyModal: "Hệ thống sẽ gửi duyệt hóa đơn này",
        });
        toggleWorkflowModal();
      },
    },
    {
      icon: <i className="bx bxs-check-circle text-success" />,
      text: "Duyệt hóa đơn",
      isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
      conditionVisible: COMMON_CONDITION_VISIBLE.APPROVE,
      onClick: row => {
        setDataWorkflow({
          id: row.invoice_id,
          typeWorkFlow: TYPE_ACTION_WORKFLOW.APPROVE,
          titleModal: "Xác nhận duyệt phát hành hóa đơn này",
          bodyModal: "Hệ thống sẽ duyệt phát hành hóa đơn này",
        });
        setTransferData({
          id: row.invoice_id,
          mst: row.nban_mst,
          resource_id: getResourceIdXML(row.resource_list, "raw"),
          type: TYPE_TRANSFER.INVOICE,
          invoice_type: row.invoice_type,
        });
        toggleWorkflowModal();
      },
    },
    {
      icon: <i className="bx bxs-x-circle text-danger" />,
      text: "Từ chối duyệt hóa đơn",
      isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
      conditionVisible: COMMON_CONDITION_VISIBLE.REJECT_APPROVE,
      onClick: row => {
        setDataWorkflow({
          id: row.invoice_id,
          typeWorkFlow: TYPE_ACTION_WORKFLOW.REJECT,
          titleModal: "Xác nhận từ chối duyệt phát hành hóa đơn này",
          bodyModal: "Lý do từ chối",
        });
        toggleWorkflowModal();
      },
    },
    // Phat hanh truong hop k có cap duyet
    {
      icon: <i className="bx bx-send text-success" />,
      text: "Phát hành hóa đơn",
      isShow: finalBuInfo?.need_approve === 0,
      conditionVisible: COMMON_CONDITION_VISIBLE.RELEASE,
      onClick: row => {
        checkBeforeRelease(row);
      },
    },
    // Phat hanh truong hop có cap duyet và đã duyệt (Role kế toán)
    {
      icon: <i className="bx bx-send text-success" />,
      text: "Phát hành hóa đơn đã duyệt",
      isShow: finalBuInfo?.need_approve === 1 && isRoleAccountant,
      conditionVisible: COMMON_CONDITION_VISIBLE.RELEASE_APPROVED,
      onClick: row => {
        checkBeforeRelease(row);
      },
    },
    // {
    //   icon: <i className="bx bx-send text-success" />,
    //   text: "Phát hành hóa đơn", // Trường hợp phát hành hóa đơn doanh nghiệp k cần gửi duyệt,bắn  từ api QUEUE_MSEAG
    //   isShow: finalBuInfo?.need_approve === 1,
    //   conditionVisible: {
    //     resource_id: [],
    //     // campaign_id: [null],
    //     auth_status: [AUTH_STATUS_NEW, AUTH_STATUS_RR],
    //     auto_sign: [0],
    //     // approve_status: [APPROVE_STATUS_A],
    //     source: [SOURCE_QUEUE.QUEUE_MSEAG],
    //   },
    //   onClick: row => {
    //     checkBeforeRelease(row);
    //   },
    // },
    // {
    //   icon: <i className="bx bxs-file-pdf text-danger" />,
    //   isDropdown: true,
    //   isShow: finalBuInfo?.can_convert === 1,
    //   classDropdown: "dropdown-menu-3",
    //   listDropdown: [
    //     // Trước khi phát hành thì đều dc xem
    //     {
    //       text: "Bản hiển thị",
    //       conditionVisible: {
    //         auth_status: [AUTH_STATUS_NEW],
    //       },
    //       icon: <i className="bx bxs-file-pdf text-primary" />,
    //       onClick: row => {
    //         showPdfById(row.invoice_id);
    //       },
    //     },
    //     // Sau khi phát hành thì chỉ dc xem khi có Role ViewOriginalPdf
    //     {
    //       icon: <i className="bx bxs-file-pdf text-danger" />,
    //       text: "Bản hiển thị",
    //       conditionVisible: {
    //         auth_status:
    //           listStatusFilter.filter(item => item !== AUTH_STATUS_NEW).length >
    //           0
    //             ? listStatusFilter.filter(item => item !== AUTH_STATUS_NEW)
    //             : ["NOT_SHOW"],
    //       },
    //       isShow:
    //         (isBuHavePdfCopy && isRoleViewOriginalPdf) || !isBuHavePdfCopy,
    //       onClick: row => {
    //         showPdfById(row.invoice_id, false, isBuHavePdfCopy);
    //       },
    //     },
    //     // Sau khi phát hành thì đều dc xem pdf copy
    //     {
    //       icon: <i className="bx bxs-file-pdf text-warning" />,
    //       text: "Xem PDF dạng Copied",
    //       isShow: isBuHavePdfCopy,
    //       conditionVisible: {
    //         auth_status:
    //           listStatusFilter.filter(item => item !== AUTH_STATUS_NEW).length >
    //           0
    //             ? listStatusFilter.filter(item => item !== AUTH_STATUS_NEW)
    //             : ["NOT_SHOW"],
    //       },
    //       onClick: row => {
    //         showPdfById(row.invoice_id);
    //       },
    //     },
    //     {
    //       text: "Bản chuyển đổi",
    //       icon: <i className="bx bxs-file-pdf text-success" />,
    //       conditionVisible: {
    //         auth_status: [AUTH_STATUS_APPROVE],
    //       },
    //       onClick: row => {
    //         showPdfById(row.invoice_id, true);
    //       },
    //     },
    //   ],
    //   text: "Xem file PDF",
    // },
    // Trước khi phát hành thì đều dc xem
    {
      icon: <i className="bx bxs-file-pdf text-danger" />,
      text: "Xem trước bản hiển thị",
      conditionVisible: {
        auth_status: [AUTH_STATUS_NEW],
      },
      isShow:
        finalBuInfo?.can_convert === 0 ||
        finalBuInfo?.can_convert === undefined,
      onClick: row => {
        showPdfById(row.invoice_id);
      },
    },
    // Sau khi phát hành thì chỉ dc xem khi có Role ViewOriginalPdf
    {
      icon: <i className="bx bxs-file-pdf text-danger" />,
      text: "Xem trước bản hiển thị",
      conditionVisible: {
        auth_status:
          listStatusFilter.filter(item => item !== AUTH_STATUS_NEW).length > 0
            ? listStatusFilter.filter(item => item !== AUTH_STATUS_NEW)
            : ["NOT_SHOW"],
      },
      isShow:
        ((isBuHavePdfCopy && isRoleViewOriginalPdf) || !isBuHavePdfCopy) &&
        (finalBuInfo?.can_convert === 0 ||
          finalBuInfo?.can_convert === undefined),
      onClick: row => {
        showPdfById(row.invoice_id, false, isBuHavePdfCopy);
      },
    },
    // Sau khi phát hành thì đều dc xem pdf copy
    {
      icon: <i className="bx bxs-file-pdf text-warning" />,
      text: "Xem PDF dạng Copied",
      conditionVisible: {
        auth_status:
          listStatusFilter.filter(item => item !== AUTH_STATUS_NEW).length > 0
            ? listStatusFilter.filter(item => item !== AUTH_STATUS_NEW)
            : ["NOT_SHOW"],
      },
      isShow:
        isBuHavePdfCopy &&
        (finalBuInfo?.can_convert === 0 ||
          finalBuInfo?.can_convert === undefined),
      onClick: row => {
        showPdfById(row.invoice_id);
      },
    },
    // Gửi mail bình thường
    {
      icon: <i className="bx bx-mail-send text-success" />,
      text: "Gửi mail",
      isShow:
        (!isRoleStore || !tenantCodeHeader.includes("PNJ")) &&
        buStoreHeader !== ALL_STORE &&
        buStoreHeader !== ALL_BU &&
        !isPreventSendMailFromSecond,
      conditionVisible: {
        auth_status: [AUTH_STATUS_APPROVE],
      },
      onClick: row => {
        showSendMail(row);
      },
    },
    // Gửi mail bên PNJ trường hợp chưa gửi mail
    {
      icon: <i className="bx bx-mail-send text-success" />,
      text: "Gửi mail",
      isShow:
        (!isRoleStore || !tenantCodeHeader.includes("PNJ")) &&
        buStoreHeader !== ALL_STORE &&
        buStoreHeader !== ALL_BU &&
        isPreventSendMailFromSecond,
      conditionVisible: {
        auth_status: [AUTH_STATUS_APPROVE],
        sent: [0],
      },
      onClick: row => {
        showSendMail(row);
      },
    },
    // Gửi mail bên PNJ trường hợp đã gửi mail thành công và mún gửi tiếp thì phải có role cho phép
    {
      icon: <i className="bx bx-mail-send text-success" />,
      text: "Gửi mail",
      isShow:
        (!isRoleStore || !tenantCodeHeader.includes("PNJ")) &&
        buStoreHeader !== ALL_STORE &&
        buStoreHeader !== ALL_BU &&
        isPreventSendMailFromSecond &&
        isRoleContinueSendMail,
      conditionVisible: {
        auth_status: [AUTH_STATUS_APPROVE],
        sent: [1],
      },
      onClick: row => {
        showSendMail(row);
      },
    },
    {
      icon: <i className="far fa-newspaper text-success" />,
      isDropdown: true,
      classDropdown: "dropdown-menu-2",
      listDropdown: [
        {
          icon: <i className="bx bx-rotate-left text-primary" />,
          text: "Thay thế",
          //   isCurrentMonthOnly: isEnterprise,
          isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
          conditionVisible: COMMON_CONDITION_VISIBLE.REPLACE,
          onClick: row => {
            setDataConfirmAction({
              id: row.invoice_id,
              mode: MODE_INVOICE_POS_ACTION.REPLACE,
              pattern: row.ttchung_khmshdon,
              serial: row.ttchung_khhdon,
              invoiceNo: row.ttchung_shdon,
              nlap: row.ttchung_nlap,
            });
            setPageViewByRow(row);
            toggleConfirmActionModal();
          },
        },
        {
          icon: <i className="bx bx-edit text-primary" />,
          text: "Điều chỉnh",
          isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
          conditionVisible: COMMON_CONDITION_VISIBLE.ADJUST,
          onClick: row => {
            setDataConfirmAction({
              id: row.invoice_id,
              mode: MODE_INVOICE_POS_ACTION.ADJUST,
              pattern: row.ttchung_khmshdon,
              serial: row.ttchung_khhdon,
              invoiceNo: row.ttchung_shdon,
              nlap: row.ttchung_nlap,
            });
            setPageViewByRow(row);
            toggleConfirmActionModal();
          },
        },
        {
          icon: <i className="bx bx-trash text-danger" />,
          text: "Hủy",
          isShow:
            !isRoleStore &&
            buStoreHeader !== ALL_STORE &&
            buStoreHeader !== ALL_BU,
          conditionVisible: COMMON_CONDITION_VISIBLE.CANCEL,
          onClick: row => {
            setDataViewDocument({
              id: row.invoice_id,
              gui_hdth: row.gui_hdth,
            });
            toggleConfirmCancelModal();
          },
        },
      ],
      text: "Nghiệp vụ",
    },
    // {
    //   icon: <i className="bx bx-cloud-download text-primary" />,
    //   isDropdown: true,
    //   conditionVisible: {
    //     // ttchung_shdon: [null],
    //     auth_status: [AUTH_STATUS_APPROVE],
    //   },
    //   listDropdown: [
    //     {
    //       text: "Biên bản điều chỉnh hóa đơn",
    //       icon: <i className="fas fa-file-word text-primary" />,
    //       onClick: row => {
    //         dispatch(
    //           getInvoicePosReportWord(
    //             row.invoice_id,
    //             TYPE_REPORT_WORD.ADJUST,
    //             getPathNameFile(row, "bienbandieuchinhhoadon")
    //           )
    //         );
    //       },
    //     },
    //     {
    //       text: "Biên bản hủy hóa đơn",
    //       icon: <i className="fas fa-file-word text-danger" />,
    //       onClick: row => {
    //         dispatch(
    //           getInvoicePosReportWord(
    //             row.invoice_id,
    //             TYPE_REPORT_WORD.CANCEL,
    //             getPathNameFile(row, "bienbanhuy")
    //           )
    //         );
    //       },
    //     },
    //     {
    //       text: "Biên bản điều chỉnh thông tin khách hàng",
    //       icon: <i className="fas fa-file-word text-success" />,
    //       onClick: row => {
    //         dispatch(
    //           getInvoicePosReportWord(
    //             row.invoice_id,
    //             TYPE_REPORT_WORD.INFO,
    //             getPathNameFile(row, "bienbandieuchinhthongtinkhachhang")
    //           )
    //         );
    //       },
    //     },
    //     {
    //       text: "Biên bản trả hàng",
    //       icon: <i className="fas fa-file-word text-warning" />,
    //       onClick: row => {
    //         dispatch(
    //           getInvoicePosReportWord(
    //             row.invoice_id,
    //             TYPE_REPORT_WORD.GRA,
    //             getPathNameFile(row, "bienbantrahang")
    //           )
    //         );
    //       },
    //     },
    //   ],
    //   text: "Tải biên bản",
    // },
    {
      icon: <i className="bx bx-trash text-danger" />,
      text: "Xóa bỏ",
      isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: COMMON_CONDITION_VISIBLE.DELETE,
      onClick: row => {
        setDataViewDocument({
          id: row.invoice_id,
        });
        toggleConfirmDeleteModal();
      },
    },
    // {
    //   icon: <i className="bx bx-history text-success" />,
    //   text: "Lịch sử truyền nhận",
    //   onClick: row => {
    //     setIdHistory(row.invoice_id);
    //     toggleHistoryTransferModal();
    //   },
    // },
    {
      icon: <i className="bx bx-history font-size-18 text-warning" />,
      text: "Lịch sử gửi mail",
      onClick: row => {
        setIdHistoryMail(row.invoice_id);
        toggleHistoryMailTransferModal();
      },
    },
    {
      icon: <i className="bx bx-edit text-success" />,
      text: isEnterprise ? "Tạo hóa đơn cho doanh nghiệp" : "Cập nhật hóa đơn",
      isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: COMMON_CONDITION_VISIBLE.EDIT,
      onClick: row => {
        // getListInvoiceSymbol(row.ttchung_khmshdon);
        if (row.tthdlquan_tchdon) {
          let mode = null;
          if (row.tthdlquan_lhdclquan === "3") {
            mode = MODE_INVOICE_POS_ACTION.REPLACE;
          } else {
            switch (row.tthdlquan_tchdon) {
              case "1":
                mode = MODE_INVOICE_POS_ACTION.REPLACE;
                break;
              case "2":
                mode = MODE_INVOICE_POS_ACTION.ADJUST;
                break;
              default:
                break;
            }
          }
          setDataConfirmAction({
            modeEdit: mode,
            typeAdjust: row.adjust_mod,
          });
        } else {
          setDataConfirmAction(null);
        }
        setPageViewByRow(row);
        setDataDetail({
          id: row.invoice_id,
          tthdlquan_tchdon: row.tthdlquan_tchdon,
          root: row.root,
          child: row.child,
          tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
          tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
          tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
          tthdlquan_shdclquan: row.tthdlquan_shdclquan,
          tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
        });
        switch (row.ttchung_khmshdon) {
          case "1":
            setMode(invoicePosModeList.EDIT_VAT_INVOICE_DETAIL);
            break;
          case "2":
            setMode(invoicePosModeList.EDIT_SALE_INVOICE_DETAIL);
            break;
          default:
            break;
        }
        toggleDetailModal();
      },
    },
    {
      icon: <i className="bx bx-edit text-success" />,
      text: isEnterprise ? "Tạo hóa đơn cho doanh nghiệp" : "Cập nhật hóa đơn", // Trường hợp hóa đơn bắn  từ api QUEUE_MSEAG
      isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      conditionVisible: COMMON_CONDITION_VISIBLE.EDIT_QUEUE_MSEAG,
      onClick: row => {
        // getListInvoiceSymbol(row.ttchung_khmshdon);
        if (row.tthdlquan_tchdon) {
          let mode = null;
          if (row.tthdlquan_lhdclquan === "3") {
            mode = MODE_INVOICE_POS_ACTION.REPLACE;
          } else {
            switch (row.tthdlquan_tchdon) {
              case "1":
                mode = MODE_INVOICE_POS_ACTION.REPLACE;
                break;
              case "2":
                mode = MODE_INVOICE_POS_ACTION.ADJUST;
                break;
              default:
                break;
            }
          }
          setDataConfirmAction({
            modeEdit: mode,
            typeAdjust: row.adjust_mod,
          });
        } else {
          setDataConfirmAction(null);
        }
        setPageViewByRow(row);
        setDataDetail({
          id: row.invoice_id,
          tthdlquan_tchdon: row.tthdlquan_tchdon,
          root: row.root,
          child: row.child,
          tthdlquan_lhdclquan: row.tthdlquan_lhdclquan,
          tthdlquan_khmshdclquan: row.tthdlquan_khmshdclquan,
          tthdlquan_khhdclquan: row.tthdlquan_khhdclquan,
          tthdlquan_shdclquan: row.tthdlquan_shdclquan,
          tthdlquan_nlhdclquan: row.tthdlquan_nlhdclquan,
        });
        switch (row.ttchung_khmshdon) {
          case "1":
            setMode(invoicePosModeList.EDIT_VAT_INVOICE_DETAIL);
            break;
          case "2":
            setMode(invoicePosModeList.EDIT_SALE_INVOICE_DETAIL);
            break;
          default:
            break;
        }
        toggleDetailModal();
      },
    },
    {
      icon: <i className="bx bx-download text-primary" />,
      text: "Download XML",
      isShow: !isBuHavePdfCopy,
      conditionVisible: {
        resource_id: [],
      },
      onClick: row => {
        let resource_id = null;
        let type = "";
        let mltdiep = null;
        if (row.auth_status === AUTH_STATUS_NEW) {
          type = "raw";
        } else if (row.auth_status === AUTH_STATUS_APPROVE) {
          type = "tct-response";
          switch (row.invoice_type) {
            // có mã
            case "1":
              mltdiep = "206";
              break;
            // không mã
            case "0":
              mltdiep = "204";
              break;
            default:
              break;
          }
        } else {
          type = "signed";
        }
        resource_id = getResourceIdXML(row.resource_list, type, mltdiep);
        // Mst người bán + Ký hiệu mẫu + ký hiệu hóa đơn + số hóa đơn
        const { nban_mst, ttchung_khmshdon, ttchung_khhdon, ttchung_shdon } =
          row;
        const fileName = `INVOICE-POS_${
          nban_mst ? `${nban_mst}_` : ""
        }${ttchung_khmshdon}${ttchung_khhdon}${
          ttchung_shdon ? `_${ttchung_shdon}` : ""
        }`;
        if (resource_id) {
          dispatch(downloadXmlInvoicePos(resource_id, fileName));
        } else {
          addToast("Tải xuống thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
        }
      },
    },
    // Tạo hóa đơn doanh nghiệp
    // {
    //   icon: <i className="bx bx-receipt text-success" />,
    //   text: "Tạo hóa đơn doanh nghiệp",
    //   isShow: isEnterprise,
    //   conditionVisible: {
    //     resource_id: [],
    //     auth_status: [AUTH_STATUS_APPROVE],
    //     passersbyChild: [null],
    //     passersbyRoot: [null],
    //   },
    //   onClick: row => {
    //     dispatch(createInvoicePosEnterprise(row.invoice_id, TYPE_CLONE.REPLACE_NEW));
    //   },
    // },
    // {
    //   icon: <i className="bx bxs-file-pdf text-primary" />,
    //   text: "Chính sách thu đổi",
    //   isShow: finalBuInfo?.is_exchange_policy === 1,
    //   conditionVisible: {
    //     // ttchung_shdon: [null],
    //     auth_status: [AUTH_STATUS_APPROVE],
    //   },
    //   onClick: row => {
    //     showPdfReturnGoodsById(row.invoice_id);
    //   },
    // },

    // {
    //   icon: <i className="bx bx-upload text-success" />,
    //   text: "Upload biên bản đính kèm",
    //   isShow: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
    //   conditionVisible: {
    //     // root: [null],
    //   },
    //   onClick: row => {
    //     setIdRootInvoice(row.invoice_id);
    //     toggleUploadFileModal();
    //   },
    // },
    // {
    //   icon: <i className="fas fa-copy font-size-16 text-success"></i>,
    //   isShow: finalBuInfo?.can_clone === 1,
    //   text: "Copy hóa đơn này",
    //   conditionVisible: {
    //     tthdlquan_tchdon: [null],
    //     // campaign_id: [null],
    //   },
    //   onClick: row => {
    //     cloneEnvoice(row.invoice_id);
    //   },
    // },
  ];

  const setPageViewByRow = row => {
    let pageView = "";
    if (row.invoice_type)
      switch (row.ttchung_khmshdon) {
        // Hóa đơn GTGT
        case "1":
          switch (row.invoice_type) {
            case "1":
              pageView = invoicePosPageViewList.PAGE_VAT_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = invoicePosPageViewList.PAGE_VAT_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        // Hóa đơn Bán hàng
        case "2":
          switch (row.invoice_type) {
            case "1":
              pageView = invoicePosPageViewList.PAGE_SALE_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = invoicePosPageViewList.PAGE_SALE_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    setPageView(pageView);
  };

  const actionReplaceOrAdjustInvoice = (typeAdjust, finalSerial) => {
    setDataConfirmAction({
      ...dataConfirmAction,
      finalSerial,
      typeAdjust,
    });
    setDataDetail({ id: dataConfirmAction.id });
    // getListInvoiceSymbol(dataConfirmAction.pattern);
    switch (dataConfirmAction.pattern) {
      case "1":
        setMode(invoicePosModeList.EDIT_VAT_INVOICE_DETAIL);
        break;
      case "2":
        setMode(invoicePosModeList.EDIT_SALE_INVOICE_DETAIL);
        break;
      default:
        break;
    }

    toggleDetailModal();
  };

  const listMultipleRowAction = [
    // {
    //   icon: <i className="far fa-file-excel font-size-18 text-success" />,
    //   text: "Xuất danh sách hóa đơn",
    //   isLoading: exportInvoiceData.loading,
    //   loadingText: "Đang xuất danh sách hóa đơn",
    //   onClick: data => {
    //     let objectExport = exportFormatData();
    //     objectExport = {
    //       ...objectExport,
    //       ...invoicePosList.params.columnFilter,
    //       sort: invoicePosList.params.sort
    //         ? invoicePosList.params.sort
    //         : "-checker_date",
    //       keywords: invoicePosList.params.keywords,
    //     };
    //     dispatch(
    //       exportInvoicePos(
    //         objectExport,
    //         getFileNameExcel("DanhSachHoaDon"),
    //         "invoice-pos"
    //       )
    //     );
    //   },
    // },
    // {
    //   icon: <i className="bx bx-download font-size-18 text-danger" />,
    //   text: `Download bản hiển thị của (${invoiceSelect.length}) hóa đơn`,
    //   isLoading: downloadZipInvoiceData.loading,
    //   loadingText: "Đang download bản hiển thị",
    //   onClick: data => {
    //     if (data.length === 0) {
    //       toastNoRowSelect(addToast, t);
    //     } else {
    //       dispatch(
    //         downloadZipInvoicePos(invoiceSelect, "pdf", "PDF_HOA_DON.zip")
    //       );
    //     }
    //   },
    // },
    // {
    //   icon: <i className="bx bx-download font-size-18 text-info" />,
    //   text: `Download bản chuyển đổi của (${invoiceSelect.length}) hóa đơn`,
    //   isLoading: downloadZipInvoiceData.loading,
    //   isShow: finalBuInfo?.can_convert === 1,
    //   loadingText: "Đang download bản chuyển đổi",
    //   onClick: data => {
    //     if (data.length === 0) {
    //       toastNoRowSelect(addToast, t);
    //     } else {
    //       dispatch(
    //         downloadZipInvoicePos(
    //           invoiceSelect,
    //           "convert-pdf",
    //           "PDF_HOA_DON_CHUYEN_DOI.zip"
    //         )
    //       );
    //     }
    //   },
    // },
    // {
    //   icon: <i className="bx bx-download font-size-18 text-primary" />,
    //   text: `Download XML của (${invoiceSelect.length}) hóa đơn`,
    //   isShow: !isBuHavePdfCopy,
    //   isLoading: downloadZipInvoiceData.loading,
    //   loadingText: "Đang download xml",
    //   onClick: data => {
    //     if (data.length === 0) {
    //       toastNoRowSelect(addToast, t);
    //     } else {
    //       dispatch(
    //         downloadZipInvoicePos(invoiceSelect, "xml", "XML_HOA_DON.zip")
    //       );
    //     }
    //   },
    // },
  ];

  const exportFormatData = () => {
    let objectExport = {};
    columnsTable
      .filter(item => item.hidden === false || item.hidden === undefined)
      .map(item => {
        const formatData = {
          id: item.id,
          dataField: item.dataField,
          hidden: item.hidden,
          text: item.text,
        };

        const key = `columns[${formatData.dataField}][label]`;
        // Format data
        switch (formatData.dataField) {
          case "link_type":
            for (const key in selectFilterLinkType) {
              objectExport[
                `columns[${formatData.dataField}][mapping][${key}]`
              ] = selectFilterLinkType[key];
            }
            break;
          case "pending_van":
            objectExport[`columns[${formatData.dataField}][mapping][0]`] =
              "Đã gửi";
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "Chưa gửi";
            break;
          case "auth_status":
            for (const key in selectFilterAuthStatus) {
              objectExport[
                `columns[${formatData.dataField}][mapping][${key}]`
              ] = selectFilterAuthStatus[key];
            }
            break;
          case "approve_status":
            for (const key in selectFilterApproveStatus) {
              objectExport[
                `columns[${formatData.dataField}][mapping][${key}]`
              ] = selectFilterApproveStatus[key];
            }
            break;
          case "sent":
            objectExport[`columns[${formatData.dataField}][mapping][0]`] =
              "Chưa gửi mail";
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "Đã gửi mail";
            break;
          case "ttchung_khmshdon":
            objectExport[`columns[${formatData.dataField}][mapping][1]`] =
              "HÓA ĐƠN GTGT";
            objectExport[`columns[${formatData.dataField}][mapping][2]`] =
              "HÓA ĐƠN BH";
            break;
          case "ttchung_shdon":
            objectExport[`columns[${formatData.dataField}][mapping][null]`] =
              "Chờ cấp số";
            break;
          case "ttchung_nlap":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "checker_date":
            objectExport[`columns[${formatData.dataField}][type]`] = "date";
            break;
          case "ttoan_tgtttbso":
            objectExport[`columns[${formatData.dataField}][type]`] = "currency";
            break;
          default:
            break;
        }
        // Format style
        switch (formatData.dataField) {
          case "nmua_ten":
            objectExport[
              `columns[${formatData.dataField}][contentOptions][alignment][wrapText]`
            ] = true;
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][width]`
            ] = 80;
            break;
          default:
            objectExport[
              `columns[${formatData.dataField}][dimensionOptions][autoSize]`
            ] = true;
            break;
        }
        //
        const value = formatData.text;
        objectExport[key] = value;

        return formatData;
      });
    return objectExport;
  };

  const getLinkType = row => {
    let text = "";
    let className = "";
    let type = "";
    switch (row.link_type) {
      case LINK_TYPE.PARENT_REPLACE:
        className = "text-success";
        text = `HÓA ĐƠN GỐC ${
          listLinkTypeFilter.length === 0 ? " (BỊ THAY THẾ)" : ""
        }`;
        break;
      case LINK_TYPE.PARENT_ADJUST:
        className = "text-success";
        text = `HÓA ĐƠN GỐC ${
          listLinkTypeFilter.length === 0 ? " (BỊ ĐIỀU CHỈNH)" : ""
        }`;
        break;
      case LINK_TYPE.CHILD_REPLACE:
        className = "text-info";
        text = "HÓA ĐƠN THAY THẾ";
        break;
      case LINK_TYPE.CHILD_ADJUST:
        className = "text-primary";
        switch (row.adjust_mod) {
          case TYPE_ADJUST_INVOICE_POS.INCREASE:
            type = "TĂNG";
            break;
          case TYPE_ADJUST_INVOICE_POS.DECREASE:
            type = "GIẢM";
            break;
          case TYPE_ADJUST_INVOICE_POS.CHANGE_INFO:
            type = "THÔNG TIN";
            break;
          default:
            break;
        }
        text = "HÓA ĐƠN ĐIỀU CHỈNH " + type;
        break;
      case LINK_TYPE.CHILD_REPLACE_TT32:
        className = "text-info";
        text = "HÓA ĐƠN THAY THẾ (CHO TT32)";
        break;
      case LINK_TYPE.CHILD_ADJUST_TT32:
        className = "text-primary";
        switch (row.adjust_mod) {
          case TYPE_ADJUST_INVOICE_POS.INCREASE:
            type = "TĂNG";
            break;
          case TYPE_ADJUST_INVOICE_POS.DECREASE:
            type = "GIẢM";
            break;
          case TYPE_ADJUST_INVOICE_POS.CHANGE_INFO:
            type = "THÔNG TIN";
            break;
          default:
            break;
        }
        text = "HÓA ĐƠN ĐIỀU CHỈNH " + type + " (CHO TT32)";
        break;
      default:
        className = "text-success";
        text = "HÓA ĐƠN BÌNH THƯỜNG";
        break;
    }

    return (
      <React.Fragment>
        <div className={className} style={{ fontWeight: "bold" }}>
          {text}
        </div>
      </React.Fragment>
    );
  };

  const getAuthStatus = row => {
    let status = row.auth_status;
    let process_status = row.process_status;
    let id = row.invoice_id;
    let child = row.child;
    let root = row.root;
    let infoError = null;
    let progressDiv = null;
    let info = null;
    if (
      status === AUTH_STATUS_REJECT ||
      status === AUTH_STATUS_RRE ||
      status === AUTH_STATUS_RR
    ) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(id);
            toggleErrorReleaseModal();
            setPathErrorRelease("invoice-pos");
          }}
        ></i>
      );
    }
    if (status === AUTH_STATUS_APPROVE) {
      progressDiv = (
        <div className="d-flex gap-1 mt-2">
          <Badge
            className={`font-size-12 ${commonStatus?.PROGRESS_STATUS[process_status]?.badgeColor}`}
            pill
          >
            {commonStatus?.PROGRESS_STATUS[process_status]?.text}
          </Badge>
        </div>
      );
    }
    info = getRowInvoiceReplaceAdjustInfo(
      row,
      setDataCompare,
      dispatch,
      getDataLinkPos,
      toggleCompareInvoiceModal
    );
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            style={{ width: "110px", whiteSpace: "initial" }}
            className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.AUTH_STATUS[status]?.text}
          </Badge>

          {infoError}
          {info}
        </div>
        {row.auto_sign === 1 && (
          <Badge
            style={{ width: "110px", whiteSpace: "initial", marginTop: "2px" }}
            className={`font-size-10 text-warning`}
            pill
          >
            Tự động phát hành
          </Badge>
        )}
        {/* {progressDiv} */}
      </React.Fragment>
    );
  };

  const getBathStatus = row => {
    const { batch_id, batch_status } = row;
    let infoError = null;
    if (batch_status === AUTH_STATUS_REJECT) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setIdRelease(batch_id);
            toggleErrorReleaseModal();
            setPathErrorRelease("invoice-batches");
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div>
          <div className="d-flex gap-1 mb-1">
            <Badge
              className={`font-size-12 ${commonStatusPhase?.AUTH_STATUS?.[batch_status]?.badgeColor}`}
              pill
            >
              {commonStatusPhase?.AUTH_STATUS?.[batch_status]?.text}
            </Badge>
            {infoError}
          </div>
          {batch_id && (
            <div
              onClick={() => {
                window.open(
                  `/invoice-pos/phase?filterId=${batch_id}`,
                  "_blank"
                );
              }}
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                marginLeft: "4px",
              }}
              className={`font-size-12 fw-bold text-info`}
            >
              Xem đợt gửi
            </div>
          )}
        </div>
      </React.Fragment>
    );
  };

  const getApproveStatus = row => {
    let status = row.approve_status;
    let note_deny = row.approve_note?.workflowNote;
    let infoError = null;
    if (status === APPROVE_STATUS_R) {
      infoError = (
        <i
          style={{ cursor: "pointer" }}
          title="Hiển thị lý do từ chối"
          className="font-size-17 bx bx-info-circle text-danger"
          onClick={() => {
            setNoteReject(note_deny);
            toggleRejectModal();
          }}
        ></i>
      );
    }
    return (
      <React.Fragment>
        <div className="d-flex gap-1" title={note_deny}>
          <Badge
            className={`font-size-12 ${commonStatus?.APPROVE_STATUS[status]?.badgeColor}`}
            pill
          >
            {commonStatus?.APPROVE_STATUS[status]?.text}
          </Badge>
          {infoError}
        </div>
      </React.Fragment>
    );
  };

  const getSelectFilterAuthStatus = () => {
    const filter = {};
    for (const item of listStatusFilter) {
      if (selectFilterAuthStatus[item]) {
        filter[item] = selectFilterAuthStatus[item];
      }
    }
    return filter;
  };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Đã phát hành",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Chờ phát hành",
    [AUTH_STATUS_REJECT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành",
    // [AUTH_STATUS_REPLACE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_REPLACE]?.text, // "Thay thế",
    // [AUTH_STATUS_EDIT]: commonStatus?.AUTH_STATUS[AUTH_STATUS_EDIT]?.text, // "Điều chỉnh",
    [AUTH_STATUS_CANCEL_WAITING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL_WAITING]?.text, // "Chờ duyệt hủy",
    [AUTH_STATUS_REJECT_CANCEL]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_REJECT_CANCEL]?.text, // "Từ chối hủy",
    [AUTH_STATUS_CANCEL]: commonStatus?.AUTH_STATUS[AUTH_STATUS_CANCEL]?.text, // "Hủy",

    [AUTH_STATUS_AR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_AR]?.text, // Đã tiếp nhận đăng ký
    // [AUTH_STATUS_ARE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_ARE]?.text, // Đã tiếp nhận thay đổi

    [AUTH_STATUS_RR]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RR]?.text, //"Từ chối tiếp nhận đăng ký",
    // [AUTH_STATUS_RRE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_RRE]?.text, //"Từ chối tiếp nhận thay đổi"
  };

  const selectFilterBathStatus = {
    [AUTH_STATUS_NEW]: commonStatusPhase?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatusPhase?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]:
      commonStatusPhase?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
    [AUTH_STATUS_REJECT]:
      commonStatusPhase?.AUTH_STATUS[AUTH_STATUS_REJECT]?.text, // "Từ chối phát hành"",
  };

  const getSelectFilterLinkType = () => {
    const filter = {};
    if (listLinkTypeFilter.length > 0) {
      for (const item of listLinkTypeFilter) {
        if (selectFilterLinkType[item]) {
          filter[item] = selectFilterLinkType[item];
        }
      }
      return filter;
    } else {
      return selectFilterLinkType;
    }
  };

  const selectFilterLinkType = {
    [LINK_TYPE.NORMAL]: "Hóa đơn bình thường",
    [LINK_TYPE.PARENT_REPLACE]: "Hóa đơn gốc (bị thay thế)",
    [LINK_TYPE.PARENT_ADJUST]: "Hóa đơn gốc (bị điều chỉnh)",
    [LINK_TYPE.CHILD_REPLACE]: "Hóa đơn thay thế",
    [LINK_TYPE.CHILD_ADJUST]: "Hóa đơn điều chỉnh",
    [LINK_TYPE.CHILD_REPLACE_TT32]: "Hóa đơn thay thế (cho TT32)",
    [LINK_TYPE.CHILD_ADJUST_TT32]: "Hóa đơn điều chỉnh (cho TT32)",
  };

  const getSelectFilterApproveStatus = () => {
    const filter = {};
    let listFilter = [
      APPROVE_STATUS_M,
      APPROVE_STATUS_P,
      APPROVE_STATUS_A,
      APPROVE_STATUS_R,
    ];
    if (isRoleAccountant) {
      listFilter = [APPROVE_STATUS_P, APPROVE_STATUS_A];
    }
    for (const item of listFilter) {
      if (selectFilterApproveStatus[item]) {
        filter[item] = selectFilterApproveStatus[item];
      }
    }
    return filter;
  };

  const selectFilterApproveStatus = {
    [APPROVE_STATUS_M]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_M]?.text, // "Lưu tạm",
    [APPROVE_STATUS_P]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_P]?.text, // "Gửi chờ duyệt",
    [APPROVE_STATUS_A]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_A]?.text, // "Đã duyệt",
    [APPROVE_STATUS_R]: commonStatus?.APPROVE_STATUS[APPROVE_STATUS_R]?.text, // "Từ chối duyệt",
  };

  const getClientType = row => {
    let client_type = row.client_type;
    return (
      <React.Fragment>
        <div className="d-flex gap-1">
          <Badge
            className={`font-size-12 ${commonStatus?.CLIENT_TYPE[client_type]?.badgeColor}`}
            pill
          >
            {commonStatus?.CLIENT_TYPE[client_type]?.text}
          </Badge>
        </div>
      </React.Fragment>
    );
  };

  const getSelectFilterClientType = () => {
    return selectFilterClientType;
  };

  const selectFilterClientType = {
    [CLIENT_TYPE_CONST.SALE]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE]?.text,
    [CLIENT_TYPE_CONST.SALE_ADJ]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.SALE_ADJ]?.text,
    [CLIENT_TYPE_CONST.IBT_GTGT]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_GTGT]?.text,
    [CLIENT_TYPE_CONST.GRA]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA]?.text,
    [CLIENT_TYPE_CONST.GRA_ADJ]:
      commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.GRA_ADJ]?.text,
    // [CLIENT_TYPE_CONST.IBT]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT]?.text,
    // [CLIENT_TYPE_CONST.IBT_CSM]:
    //   commonStatus?.CLIENT_TYPE[CLIENT_TYPE_CONST.IBT_CSM]?.text,
  };

  const getInitColumns = (loadDefaultFilter = false) => {
    const initColumns = [
      // {
      //   dataField: "pban",
      //   text: t("table.version"),
      //   // sort: true,
      //   // filter: textFilter({
      //   //   placeholder: t("placeholder.enter", {
      //   //     title: t("table.message_sender"),
      //   //   }),
      //   // }),
      // },
      {
        dataField: "invoice_id",
        text: "Id HĐ",
        sort: true,
        hidden: env.API_AIR_BRAKE_ENV !== "dev" || isEnterprise,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "invoice_id",
            dataDefaultFilter
          ),
          style: { minWidth: "75px" },
        }),
        formatter: (cell, row) => {
          if (cell) {
            return (
              <div style={{ fontWeight: "bold" }}>
                Id: <span className="text-info">{cell}</span>
                <div
                  onClick={() => {
                    window.open(`/invoice-pos/all?filterId=${cell}`, "_blank");
                  }}
                  style={{
                    cursor: "pointer",
                    textDecoration: "underline",
                    marginLeft: "4px",
                  }}
                  className={`font-size-12 fw-bold text-info`}
                >
                  Xem chi tiết HĐ
                </div>
              </div>
            );
          }
          return "";
        },
      },
      // {
      //   dataField: "batch_id",
      //   text: "Id đợt gửi",
      //   sort: true,
      //   hidden: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //     defaultValue: getDefaultValueFilter(
      //       loadDefaultFilter,
      //       "batch_id",
      //       dataDefaultFilter
      //     ),
      //     style: { minWidth: "75px" },
      //   }),
      // },
      {
        dataField: "mccqt",
        text: "MCCQT",
        hidden: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "mccqt",
            dataDefaultFilter
          ),
          style: { minWidth: "75px" },
        }),
      },
      // {
      //   dataField: "campaign_id",
      //   text: "Hóa đơn theo lô",
      //   sort: true,
      //   hidden: true,
      //   formatter: (cell, row) => {
      //     if (cell) {
      //       return (
      //         <div style={{ fontWeight: "bold" }}>
      //           Id: <span className="text-info">{cell}</span>
      //         </div>
      //       );
      //     }
      //     return "";
      //   },
      // },
      // {
      //   dataField: "bu_code",
      //   text: "Mã đơn vị",
      //   sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //     style: { maxWidth: "120px" },
      //     defaultValue: getDefaultValueFilter(
      //       loadDefaultFilter,
      //       "bu_code",
      //       dataDefaultFilter
      //     ),
      //   }),
      //   hidden: buStoreHeader !== ALL_STORE && buStoreHeader !== ALL_BU,
      // },
      {
        dataField: "client_ref_uuid",
        text: "Số tham chiếu",
        sort: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "client_ref_uuid",
            dataDefaultFilter
          ),
          style: { width: "120px" },
        }),
        formatter: (cell, row) => {
          return (
            <div style={{ maxWidth: "120px", whiteSpace: "initial" }}>
              {cell}
            </div>
          );
        },
      },
      // {
      //   dataField: "nmua_mkhang",
      //   text: "Mã khách hàng",
      //   hidden: isEnterprise,
      //   sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //     defaultValue: getDefaultValueFilter(
      //       loadDefaultFilter,
      //       "nmua_mkhang",
      //       dataDefaultFilter
      //     ),
      //   }),
      // },
      {
        dataField: "link_type",
        text:
          listLinkTypeFilter.length > 0
            ? listLinkTypeFilter?.includes(LINK_TYPE.PARENT_REPLACE)
              ? "Hóa đơn gốc/ Thay thế"
              : "Hóa đơn gốc/ Điều chỉnh"
            : "Hóa đơn gốc / Thay thế/ Điều chỉnh",
        hidden: listLinkTypeFilter.length === 0,
        formatter: (cellContent, row) => getLinkType(row),
        filter: selectFilter({
          placeholder: t("placeholder.select"),
          options: getSelectFilterLinkType(),
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "link_type",
            dataDefaultFilter
          ),
          // style: { maxWidth: "140px" },
        }),
      },
      {
        dataField: "nmua_ten",
        text: "Tên khách hàng",
        sort: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          style: { width: "150px" },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "nmua_ten",
            dataDefaultFilter
          ),
        }),
        formatter: (cell, row) => {
          return (
            <div style={{ width: "150px", whiteSpace: "initial" }}>{cell}</div>
          );
        },
      },
      {
        dataField: "nmua_mst",
        text: "MST KH",
        sort: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "nmua_mst",
            dataDefaultFilter
          ),
        }),
        hidden: isEnterprise,
      },
      // {
      //   dataField: "ttoan_tgtttbso",
      //   text: "Tổng tiền",
      //   sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //     style: { width: "120px" },
      //   }),
      //   formatter: (cell, row) => {
      //     return numberWithCommas(cell);
      //   },
      // },

      // {
      //   dataField: "ttchung_thdon",
      //   text: t("table.invoice_name"),
      //   sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //   }),
      // },
      // {
      //   dataField: "pending_van",
      //   text: "Trạng thái gửi lên VAN",
      //   hidden: true,
      //   formatter: (cellContent, row) => {
      //     return (
      //       <div className="d-flex gap-1">
      //         <Badge
      //           style={{ width: "110px", whiteSpace: "initial" }}
      //           className={`font-size-12 ${
      //             cellContent ? "badge-soft-warning" : "badge-soft-success"
      //           }`}
      //           pill
      //         >
      //           {cellContent ? "Chưa gửi" : "Đã gửi"}
      //         </Badge>
      //       </div>
      //     );
      //   },
      //   filter: selectFilter({
      //     placeholder: t("placeholder.select"),
      //     options: {
      //       0: "Đã gửi",
      //       1: "Chưa gửi",
      //     },
      //     defaultValue: getDefaultValueFilter(
      //       loadDefaultFilter,
      //       "pending_van",
      //       dataDefaultFilter
      //     ),
      //     style: { width: "100px" },
      //   }),
      // },
      // {
      //   dataField: "direct_pos",
      //   text: "Loại đóng gói",
      //   hidden: true,
      //   formatter: (cellContent, row) => {
      //     return (
      //       <div className="d-flex gap-1">
      //         <Badge
      //           style={{ width: "110px", whiteSpace: "initial" }}
      //           className={`font-size-12 ${
      //             cellContent ? "badge-soft-info" : "badge-soft-primary"
      //           }`}
      //           pill
      //         >
      //           {cellContent ? "Chuyển trực tiếp" : "Gom gói"}
      //         </Badge>
      //       </div>
      //     );
      //   },
      //   filter: selectFilter({
      //     placeholder: t("placeholder.select"),
      //     options: {
      //       0: "Gom gói",
      //       1: "Chuyển trực tiếp",
      //     },
      //     defaultValue: getDefaultValueFilter(
      //       loadDefaultFilter,
      //       "direct_pos",
      //       dataDefaultFilter
      //     ),
      //     style: { width: "100px" },
      //   }),
      // },
      // {
      //   dataField: "batch_status",
      //   text: "Trạng thái đợt gửi",
      //   hidden: true,
      //   formatter: (cellContent, row) => getBathStatus(row),
      //   filter: selectFilter({
      //     placeholder: t("placeholder.select"),
      //     options: selectFilterBathStatus,
      //   }),
      // },
      {
        dataField: "auth_status",
        text: t("auth_status.name"),
        hidden: false,
        formatter: (cellContent, row) => getAuthStatus(row),
        filter: selectFilter({
          placeholder: t("placeholder.select"),
          options: getSelectFilterAuthStatus(),
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "auth_status",
            dataDefaultFilter
          ),
          style: { width: "100px" },
        }),
      },
      // {
      //   dataField: "approve_status",
      //   text: "TT duyệt",
      //   hidden: finalBuInfo?.need_approve === 0,
      //   formatter: (cellContent, row) => getApproveStatus(row),
      //   filter: selectFilter({
      //     placeholder: t("placeholder.select"),
      //     options: getSelectFilterApproveStatus(),
      //     defaultValue: getDefaultValueFilter(
      //       loadDefaultFilter,
      //       "approve_status",
      //       dataDefaultFilter
      //     ),
      //     style: { width: "60px" },
      //   }),
      // },

      // {
      //   dataField: "ttchung_khmshdon",
      //   text: t("table.invoice_model_number_symbol"),
      //   hidden: true,
      // },
      {
        dataField: "ttchung_khhdon",
        text: t("table.invoice_symbol"),
        sort: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "ttchung_khhdon",
            dataDefaultFilter
          ),
          style: { minWidth: "100px" },
        }),
        formatter: (cellContent, row) =>
          row.ttchung_khmshdon + row.ttchung_khhdon,
      },
      {
        dataField: "ttchung_shdon",
        text: "Số HĐ",
        sort: true,
        filter: textFilter({
          placeholder: t("placeholder.enter"),
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "ttchung_shdon",
            dataDefaultFilter
          ),
          style: { minWidth: "100px" },
        }),
        formatter: (cellContent, row) => {
          return cellContent !== "0" && cellContent
            ? cellContent
            : "Chờ cấp số";
        },
      },
      {
        dataField: "ttchung_nlap",
        text: t("table.date_created"),
        formatter: (cellContent, row) =>
          tableFormateDate(row.ttchung_nlap, false, true),
        filter: customFilter({
          type: CUSTOM_DATE_FILTER_TABLE_TYPE,
        }),
        filterRenderer: (onFilter, column) => (
          <CustomDateFilter
            onFilter={onFilter}
            column={column}
            defaultValue={getDefaultValueFilter(
              loadDefaultFilter,
              "ttchung_nlap",
              dataDefaultFilter
            )}
            paramFilter={invoicePosList.params.columnFilter}
          />
        ),
      },
      {
        dataField: "ttchung_khmshdon",
        text: "Loại Hóa đơn",
        hidden: false,
        formatter: (cellContent, row) => {
          let content = "";
          let info = null;
          let passersbyRoot = row.passersbyRoot;
          let passersbyChild = row.passersbyChild;
          if (passersbyRoot) {
            info = (
              <div
                id={"message" + row.invoice_id}
                className="font-size-14 text-primary d-flex gap-1 align-items-center"
                style={{ cursor: "pointer" }}
              >
                Cho doanh nghiệp
                <i
                  //   style={{ cursor: "pointer" }}
                  className="bx bx-info-circle text-primary"
                ></i>
                <UncontrolledTooltip
                  placement="left"
                  style={{
                    textAlign: "left",
                    fontSize: "15px",
                    background: "white",
                    color: "black",
                    border: "1px solid blue",
                    minWidth: "300px",
                  }}
                  target={"message" + row.invoice_id}
                >
                  <span style={{ fontWeight: "bold" }} className="text-primary">
                    Được tạo từ hóa đơn khách hàng lẻ.
                  </span>{" "}
                  <br />
                  Số hóa đơn: {passersbyRoot.ttchung_shdon} <br />
                  Ký hiệu: {passersbyRoot.ttchung_khmshdon}
                  {passersbyRoot.ttchung_khhdon}
                  <br />
                  Id: {passersbyRoot.id}
                </UncontrolledTooltip>
              </div>
            );
          }
          if (passersbyChild) {
            info = (
              <div
                style={{ cursor: "pointer" }}
                id={"message" + row.invoice_id}
                className="font-size-14 text-success d-flex gap-1 align-items-center"
              >
                Cho khách hàng lẻ
                <i
                  //   style={{ cursor: "pointer" }}
                  className="bx bx-info-circle text-success"
                ></i>
                <UncontrolledTooltip
                  placement="left"
                  style={{
                    textAlign: "left",
                    fontSize: "15px",
                    background: "white",
                    color: "black",
                    border: "1px solid green",
                    minWidth: "300px",
                  }}
                  target={"message" + row.invoice_id}
                >
                  <span style={{ fontWeight: "bold" }} className="text-success">
                    Đã tạo hóa đơn doanh nghiệp
                  </span>{" "}
                  <br />
                  Số hóa đơn:{" "}
                  {passersbyChild.ttchung_shdon
                    ? passersbyChild.ttchung_shdon
                    : "Chưa cấp số"}{" "}
                  <br />
                  Ký hiệu: {passersbyChild.ttchung_khmshdon}
                  {passersbyChild.ttchung_khhdon}
                  <br />
                  Id: {passersbyChild.id}
                </UncontrolledTooltip>
              </div>
            );
          }
          switch (cellContent) {
            case "1":
              content = "HĐ GTGT";
              break;
            case "2":
              content = "HĐ BH";
              break;
            default:
              break;
          }
          return (
            <React.Fragment>
              <div style={{ width: "150px", whiteSpace: "initial" }}>
                <div>{content}</div> {info}
              </div>
            </React.Fragment>
          );
        },
        filter: selectFilter({
          placeholder: t("placeholder.select"),
          options: {
            1: "HÓA ĐƠN GTGT",
            2: "HÓA ĐƠN BH",
          },
          defaultValue: getDefaultValueFilter(
            loadDefaultFilter,
            "ttchung_khmshdon",
            dataDefaultFilter
          ),
        }),
      },
      // {
      //   dataField: "sent",
      //   text: "Trạng thái gửi mail",
      //   hidden: isEnterprise,
      //   sort: true,
      //   formatter: (cellContent, row) => {
      //     if (cellContent === 0) {
      //       return (
      //         <div className="d-flex gap-1 mt-2">
      //           <Badge className={`font-size-12 badge-soft-warning`} pill>
      //             Chưa gửi mail
      //           </Badge>
      //         </div>
      //       );
      //     } else if (cellContent === 1) {
      //       return (
      //         <div className="d-flex gap-1 mt-2">
      //           <Badge className={`font-size-12 badge-soft-success`} pill>
      //             Đã gửi mail
      //           </Badge>
      //         </div>
      //       );
      //     }
      //   },
      //   filter: selectFilter({
      //     placeholder: t("placeholder.select"),
      //     options: {
      //       0: "Chưa gửi mail",
      //       1: "Đã gửi mail",
      //     },
      //     defaultValue: getDefaultValueFilter(
      //       loadDefaultFilter,
      //       "sent",
      //       dataDefaultFilter
      //     ),
      //   }),
      // },
      // {
      //   dataField: "display_name",
      //   fieldSearch: "display_name",
      //   text: t("table.maker_id"),
      //   hidden: isEnterprise,
      //   sort: true,
      //   filter: textFilter({
      //     placeholder: t("placeholder.enter"),
      //     style: { minWidth: "75px" },
      //     defaultValue: getDefaultValueFilter(
      //       loadDefaultFilter,
      //       "display_name",
      //       dataDefaultFilter
      //     ),
      //   }),
      // },
      // {
      //   dataField: "checker_date",
      //   text: t("table.checker_date"),
      //   hidden: isEnterprise,
      //   sort: true,
      //   formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      //   filter: customFilter({
      //     type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      //   }),
      //   filterRenderer: (onFilter, column) => (
      //     <CustomDateFilter
      //       onFilter={onFilter}
      //       column={column}
      //       defaultValue={getDefaultValueFilter(
      //         loadDefaultFilter,
      //         "checker_date",
      //         dataDefaultFilter
      //       )}
      //       paramFilter={invoicePosList.params.columnFilter}
      //     />
      //   ),
      // },
      // {
      //   dataField: "client_type",
      //   text: "Nguồn",
      //   hidden: !isEnterprise,
      //   formatter: (cellContent, row) => getClientType(row),
      //   filter: selectFilter({
      //     placeholder: t("placeholder.select"),
      //     options: getSelectFilterClientType(),
      //     style: { width: "138px" },
      //     defaultValue: getDefaultValueFilter(
      //       loadDefaultFilter,
      //       "client_type",
      //       dataDefaultFilter
      //     ),
      //   }),
      // },
    ];
    return initColumns;
  };

  const resetDataFunc = () => {
    invoicePosList.params.columnFilter = {
      ...invoicePosList.params.columnFilter,
      ...filterList,
    };
    queryData();
  };

  useImperativeHandle(ref, () => ({
    queryData() {
      queryData();
    },
  }));

  return (
    <React.Fragment>
      <div className={`${!isModal ? "page-content badge-soft" : ""}`}>
        {!isModal && (
          <MetaTags>
            <title>{t(title)}</title>
          </MetaTags>
        )}

        <div className="container-fluid">
          {!isModal ? (
            <Breadcrumbs
              title={t(titleManger)}
              breadcrumbItem={t(title) + ` (${invoicePosList.totalCount})`}
            />
          ) : (
            <h4 className="mb-0 font-size-18">
              {t(title) + ` (${invoicePosList.totalCount})`}
            </h4>
          )}
          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              <AutoReloadList
                listData={invoicePosList.items}
                dataCheck={bkDataNew}
                actionReset={() => {
                  dispatch(resetBackupDataNew());
                }}
                actionReload={() => {
                  queryData(false, false);
                }}
              />
              {/* CheckRelease modal */}
              <ConfirmModal
                isOpen={modalCheckRelease}
                titleHeader={"Xác nhận Phát hành hóa đơn"}
                titleBody={titleBodyCheckRelease}
                onConfirm={note => {
                  toggleCheckReleaseModal();
                  if (!detailModal) {
                    // phát hành ngoài list
                    releaseInvoiceFunc(rowRelease);
                  } else {
                    // phát hành trong detail
                    childRef?.current?.releaseFromDetail();
                  }
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleCheckReleaseModal}
              />
              {/* CheckRelease modal */}
              <ConfirmModal
                isOpen={modalDenyRelease}
                titleHeader={"Từ chối phát hành hóa đơn"}
                titleBody={titleBodyDenyRelease}
                onConfirm={note => {
                  toggleDenyReleaseModal();
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleDenyReleaseModal}
                isShowBtnConfirm={false}
              />
              {/* Deny modal */}
              <ConfirmModal
                isOpen={modalConfirmDelete}
                titleHeader={"Xác nhận xóa hóa đơn"}
                titleBody={"Hệ thống sẽ thực hiện xóa hóa đơn này ?"}
                isDisableButton={deleteInvoice.loading}
                onConfirm={note => {
                  dispatch(deleteInvoicePos(dataViewDocument.id));
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleConfirmDeleteModal}
              />
              <UploadFileAttack
                isOpen={modalUploadFile}
                idRootInvoice={idRootInvoice}
                toggle={toggleUploadFileModal}
              />
              {/* Cancel modal */}
              <ConfirmCancelInvoiceModal
                isOpen={modalConfirmCancel}
                isShowAttacksFile={true}
                titleHeader={"Xác nhận gửi thông báo hủy hóa đơn"}
                titleBody={"Nhập lí do hủy hóa đơn ?"}
                isDisableButton={cancelInvoice.loading}
                isRequireNote={false}
                isHaveNote={true}
                onConfirm={(note, listUploadId) => {
                  let type = undefined;
                  if (dataViewDocument.gui_hdth === 1) {
                    type = 1;
                  }
                  dispatch(
                    cancelInvoicePos(
                      [{ id: dataViewDocument.id, ldo: note }],
                      type,
                      null,
                      listUploadId
                    )
                  );
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleConfirmCancelModal}
              />
              <ConfirmActionInvoice
                confirmActionData={dataConfirmAction}
                isOpen={modalConfirmAction}
                toggle={toggleConfirmActionModal}
                actionReplaceOrAdjustInvoice={actionReplaceOrAdjustInvoice}
              />
              <CompareInvoiceModal
                showPdfById={showPdfById}
                setDataCompare={setDataCompare}
                dataCompare={dataCompare}
                isOpen={modalCompareInvoice}
                toggle={toggleCompareInvoiceModal}
              />
              {/* PDFViewModal */}
              <PDFViewModal
                isAllowDownload={!isBuHavePdfCopy}
                isOpen={modalPdfView}
                dataViewDocument={dataViewDocument}
                toggle={togglePdfViewModal}
              ></PDFViewModal>
              {/* SendMailModal */}
              <SendMailModal
                isOpen={modalSendMail}
                mailData={mailData}
                toggle={toggleSendMailModal}
              ></SendMailModal>
              {/* ErrorReleaseModal */}
              <ErrorReleaseModal
                isOpen={modalErrorRelease}
                toggle={toggleErrorReleaseModal}
                id={idRelease}
                path={pathErrorRelease}
              />
              {/* HistoryTransferModal */}
              <HistoryTransferModal
                isOpen={modalHistoryTransfer}
                toggle={toggleHistoryTransferModal}
                id={idHistory}
                path={"invoice-pos"}
              />
              {/* HistoryMailTransferModal */}
              <HistoryMailTransferModal
                isOpen={modalHistoryMailTransfer}
                toggle={toggleHistoryMailTransferModal}
                id={idHistoryMail}
                path={"invoices-send-mail"}
              />
              {/* Detail Modal */}
              <DetailInvoicePos
                ref={childRef}
                btnShowFooter={btnShowFooter}
                dataDetail={dataDetail}
                isEnterprise={isEnterprise}
                dataConfirmAction={dataConfirmAction}
                isOpenModal={detailModal}
                toggleModal={toggleDetailModal}
                showPdfById={showPdfById}
                mode={mode}
                pageView={pageView}
                invoiceSymbolList={invoiceSymbolList.items}
                isRoleStore={isRoleStore}
                isRoleAccountant={isRoleAccountant}
                setTitleBodyDenyRelease={setTitleBodyDenyRelease}
                toggleDenyReleaseModal={toggleDenyReleaseModal}
                setTitleBodyCheckRelease={setTitleBodyCheckRelease}
                toggleCheckReleaseModal={toggleCheckReleaseModal}
              />
              {/* Hình thức ký modal */}
              <TypeSignDigitalModal
                t={t}
                isOpen={modalTypeSign}
                transferData={transferData}
                toggle={toggleTypeSignModal}
                toggleUSBSignModal={toggleUSBSignModal}
                toggleHSMSignModal={toggleHSMSignModal}
              />
              {/* Ký USB Modal */}
              <VerifyPinUSBModal
                t={t}
                isOpen={modalUSBSign}
                isCreateAdjust={isEnterprise && isCreateAdjust}
                downloadXmlFunc={downloadXmlInvoicePos}
                transferData={transferData}
                resetDataFunc={resetDataFunc}
                toggle={toggleUSBSignModal}
              />
              {/* Ký HSM Modal */}
              <SignHSMModal
                t={t}
                isCreateAdjust={isEnterprise && isCreateAdjust}
                idAdjust={idAdjust}
                isOpen={modalHSMSign}
                transferData={transferData}
                resetDataFunc={resetDataFunc}
                invoice_type={transferData?.invoice_type}
                releaseFunc={releaseInvoicePos}
                resetReleaseFunc={resetReleaseInvoicePos}
                toggle={toggleHSMSignModal}
              />
              {/* WORKFLOW modal */}
              <ConfirmModal
                isOpen={modalWorkflow}
                titleHeader={dataWorkflow.titleModal}
                titleBody={dataWorkflow.bodyModal}
                isDisableButton={workflowInvoice.loading}
                isHaveNote={
                  dataWorkflow.typeWorkFlow === TYPE_ACTION_WORKFLOW.REJECT
                }
                onConfirm={note => {
                  dispatch(
                    actionWorkflowInvoicePos(
                      dataWorkflow.id,
                      dataWorkflow.typeWorkFlow,
                      note
                    )
                  );
                }}
                textBtnConfirm={"Xác nhận"}
                textBtnCancel={"Đóng"}
                toggle={toggleWorkflowModal}
              />
              {/*Từ chối duyệt Modal */}
              <NoteModal
                isOpen={modalReject}
                toggle={toggleRejectModal}
                note={noteReject}
                titleNote={"Lí do từ chối duyệt"}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    customClassTable={
                      isModal
                        ? "custom-remote-table-modal"
                        : "custom-remote-table"
                    }
                    screenFilterCode={screenFilterCode}
                    selectRow={selectRowCheckbox}
                    onRowsSelect={onRowsSelect}
                    // expandRow={expandRowTable}
                    isShowSTT={isEnterprise ? false : true}
                    keyField="id"
                    data={invoicePosList.items}
                    columns={columnsTable}
                    page={invoicePosList.params.page}
                    sizePerPage={invoicePosList.params.sizePerPage}
                    totalSize={invoicePosList.totalCount}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    optionShowColumnHandel={optionShowColumnHandler}
                    rowEvents={rowEventsHandler}
                    listMultipleRowAction={listMultipleRowAction}
                    listRowAction={[]}
                    loading={loadingList}
                    resetFilterHandle={resetFilterHandle}
                  >
                    {!isModal && (
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          if (toastWarningIsAllStore(addToast)) {
                            return;
                          }
                          history.push("/invoice-pos/create?is-pos=true");
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        {t("table.btn_create")}
                      </Button>
                    )}
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
});

ListInvoicePosBatchDetail.propTypes = {
  filterList: PropTypes.object.isRequired,
  title: PropTypes.string,
  titleManger: PropTypes.string,
  listStatusFilter: PropTypes.array,
  listLinkTypeFilter: PropTypes.array,
  screenFilterCode: PropTypes.string,
  isModal: PropTypes.bool,
  typeInvoicePosAnother: PropTypes.string,
};

ListInvoicePosBatchDetail.defaultProps = {
  filterList: {},
  listStatusFilter: [],
  listLinkTypeFilter: [],
  screenFilterCode: null,
  isModal: false,
};

export default ListInvoicePosBatchDetail;
